import React from 'react';
import './PrivacyPolicy.css';

export default function TermsOfService() {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy__hero">
        <div className="container">
          <h1>Terms of Use</h1>
          <p className="privacy-policy__date">Effective Date: December 1, 2024</p>
        </div>
      </div>

      <div className="container privacy-policy__content">
        <div className="privacy-policy__contact-box">
          <p><strong>Vision Sécurité Inc.</strong></p>
          <p>Address: 3285 Boul. Cavendish, Suite 620, Montréal, Québec H4B 2L9, Canada</p>
          <p>Email: <a href="mailto:info@vision-security.ca">info@vision-security.ca</a></p>
          <p>Phone: <a href="tel:+15142797209">(514) 279-7209</a></p>
        </div>

        <p style={{fontWeight: 'bold', fontSize: '1.1rem', marginBottom: '20px'}}>
          PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING THIS WEBSITE
        </p>

        <section>
          <h2>1. Introduction and Acceptance</h2>
          <p>
            These Terms of Use ("Terms") constitute a legally binding agreement between you (whether personally or on 
            behalf of an entity) and Vision Sécurité Inc. ("Vision Sécurité," "we," "us," or "our") governing your access 
            to and use of the website www.vision-security.ca and any related subdomains, mobile applications, or other 
            digital platforms operated by Vision Sécurité (collectively, the "Website").
          </p>
          <p>
            By accessing or using the Website, you acknowledge that you have read, understood, and agree to be bound by 
            these Terms and our Privacy Policy. If you do not agree to these Terms, you must immediately discontinue use 
            of the Website.
          </p>
          <p>We recommend that you print or save a copy of these Terms for your records.</p>
        </section>

        <section>
          <h2>2. Who We Are and How to Contact Us</h2>
          <p>
            Vision Sécurité Inc. is a professional security services company registered and operating in the Province of 
            Quebec, Canada. We provide comprehensive security solutions including uniformed security guards, mobile patrol 
            services, access control, incident response, and specialized security consulting across Montreal, Laval, and 
            the Greater Quebec Area.
          </p>
          <p><strong>Registered Office:</strong> 3285 Boul. Cavendish, Suite 620, Montréal, Québec H4B 2L9, Canada</p>
          <p><strong>Contact Information:</strong></p>
          <ul>
            <li>General Inquiries: <a href="mailto:info@vision-security.ca">info@vision-security.ca</a></li>
            <li>Website/Terms Inquiries: <a href="mailto:info@vision-security.ca">info@vision-security.ca</a></li>
            <li>Phone: <a href="tel:+15142797209">(514) 279-7209</a></li>
          </ul>
          <p>
            For privacy-related matters, please contact our Privacy Officer as specified in our Privacy Policy.
          </p>
        </section>

        <section>
          <h2>3. Additional Policies and Documents</h2>
          <p>These Terms incorporate by reference and should be read in conjunction with the following additional policies:</p>
          <ul>
            <li>
              <strong>Privacy Policy:</strong> Sets out how we collect, use, disclose, and protect your personal information 
              in compliance with Quebec Law 25 and PIPEDA.
            </li>
            <li>
              <strong>Cookie Policy:</strong> Explains how we use cookies and similar tracking technologies on the Website.
            </li>
          </ul>
          <p>
            If you request a security service quote, proposal, or enter into a service agreement with Vision Sécurité, the 
            terms and conditions of that specific contract will govern the provision of security services. In the event of 
            any conflict between these Terms of Use and a signed service agreement, the service agreement shall prevail with 
            respect to the services provided.
          </p>
        </section>

        <section>
          <h2>4. Eligibility to Use the Website</h2>
          <p>By using the Website, you represent and warrant that:</p>
          <ul>
            <li>You are at least eighteen (18) years of age or the age of majority in your jurisdiction, whichever is greater</li>
            <li>You possess the legal capacity to enter into a binding agreement</li>
            <li>You are not prohibited by law from accessing or using the Website</li>
            <li>All information you provide to us is accurate, current, and complete</li>
          </ul>
          <p>
            If you are accessing the Website on behalf of a business or organization, you represent that you have the 
            authority to bind that entity to these Terms.
          </p>
        </section>

        <section>
          <h2>5. Changes to These Terms</h2>
          <p>
            We reserve the right to modify, amend, or update these Terms at any time to reflect changes in our operations, 
            legal requirements, or business practices.
          </p>
          <p>
            When we make changes, we will update the "Last Updated" date at the top of this page. For material changes that 
            significantly affect your rights or obligations, we will provide additional notice through a prominent announcement 
            on the Website or via email to registered users where appropriate.
          </p>
          <p>
            Your continued use of the Website following the posting of revised Terms constitutes your acceptance of such 
            changes. We encourage you to review these Terms periodically to stay informed of any updates.
          </p>
        </section>

        <section>
          <h2>6. Changes to the Website</h2>
          <p>
            We may update, modify, suspend, or discontinue the Website or any portion thereof at any time without prior 
            notice to reflect changes in our services, user needs, technological requirements, or business priorities.
          </p>
          <p>
            We do not guarantee that the Website, or any content, features, or functionality on it, will always be available, 
            uninterrupted, secure, or error-free. We may suspend, withdraw, or restrict access to all or any part of the 
            Website for business, operational, maintenance, or security reasons.
          </p>
          <p>
            The Website is provided free of charge. We are not liable for any suspension, modification, or discontinuation 
            of the Website or any part thereof.
          </p>
        </section>

        <section>
          <h2>7. User Accounts and Security</h2>
          <p>
            Certain areas of the Website may require registration or the creation of a user account. If you are provided 
            with or choose a username, password, or any other security credentials, you must:
          </p>
          <ul>
            <li>Treat such information as strictly confidential</li>
            <li>Not disclose your credentials to any third party</li>
            <li>Notify us immediately at <a href="mailto:info@vision-security.ca">info@vision-security.ca</a> if you know 
            or suspect unauthorized access to your account</li>
            <li>Be responsible for all activities that occur under your account</li>
          </ul>
          <p>
            We reserve the right to disable, suspend, or terminate any user account or access credentials at any time, with 
            or without notice, if we reasonably believe you have violated these Terms or engaged in conduct that is harmful 
            to the Website, other users, or our business.
          </p>
        </section>

        <section>
          <h2>8. Intellectual Property Rights</h2>
          <h3>Ownership</h3>
          <p>
            Vision Sécurité and our licensors own all intellectual property rights in the Website and its content, including 
            but not limited to text, graphics, logos, images, photographs, videos, audio clips, software, code, design 
            elements, trademarks, service marks, and trade names (collectively, "Content"). The Content is protected by 
            Canadian and international copyright, trademark, and other intellectual property laws.
          </p>
          
          <h3>Limited License</h3>
          <p>
            Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable, revocable 
            license to access and use the Website for personal, non-commercial purposes only.
          </p>
          
          <h3>Permitted Uses</h3>
          <p>You may:</p>
          <ul>
            <li>View and browse the Website for your personal or internal business use</li>
            <li>Print or download single copies of individual pages for personal reference</li>
            <li>Share links to the Website with others within your organization for legitimate business purposes related to 
            security services</li>
          </ul>
          
          <h3>Prohibited Uses</h3>
          <p>You may not:</p>
          <ul>
            <li>Modify, reproduce, distribute, display, perform, publish, or create derivative works from any Content without 
            our prior written consent</li>
            <li>Use any Content for commercial purposes without obtaining a license from us or our licensors</li>
            <li>Remove, alter, or obscure any copyright, trademark, or other proprietary notices from the Content</li>
            <li>Use any illustrations, photographs, videos, graphics, or other visual elements separately from accompanying text</li>
            <li>Use framing, deep-linking, page-scraping, robots, spiders, crawlers, or any automated tools to access, copy, 
            or monitor the Website or extract data</li>
            <li>Reverse engineer, decompile, or disassemble any software or technology underlying the Website</li>
            <li>Circumvent any security features, access controls, or technological protection measures on the Website</li>
          </ul>
        </section>

        <section>
          <h2>9. Trademarks</h2>
          <p>
            The name "Vision Sécurité," our logo, and all related names, logos, product and service names, designs, and 
            slogans are trademarks of Vision Sécurité Inc. or our licensors. You may not use these trademarks without our 
            prior written permission. All other names, logos, and marks mentioned on the Website are the trademarks of their 
            respective owners.
          </p>
        </section>

        <section>
          <h2>10. Prohibited Conduct and Acceptable Use</h2>
          <p>
            You agree to use the Website only for lawful purposes and in accordance with these Terms. Specifically, you 
            agree NOT to engage in any illegal or harmful activities, content violations, technical interference, or data 
            misuse as detailed in our complete Terms.
          </p>
          <p>
            We reserve the right to investigate and take appropriate legal action against anyone who violates these 
            prohibitions, including reporting violations to law enforcement authorities and cooperating with investigations.
          </p>
        </section>

        <section>
          <h2>11. Third-Party Links and Resources</h2>
          <p>
            The Website may contain links to third-party websites, applications, services, or resources that are not owned, 
            operated, or controlled by Vision Sécurité. These links are provided for your convenience and informational 
            purposes only.
          </p>
          <p>
            We do not endorse, approve, monitor, or assume any responsibility for third-party content. Your use of 
            third-party websites is at your own risk and subject to their terms and conditions.
          </p>
        </section>

        <section>
          <h2>12. Disclaimer of Warranties</h2>
          <p style={{fontWeight: 'bold', textTransform: 'uppercase'}}>
            THE WEBSITE AND ALL CONTENT ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, 
            EITHER EXPRESS OR IMPLIED.
          </p>
          <p>
            To the fullest extent permitted by applicable law, Vision Sécurité disclaims all warranties, including implied 
            warranties of merchantability, fitness for a particular purpose, title, and non-infringement.
          </p>
        </section>

        <section>
          <h2>13. Limitation of Liability</h2>
          <p style={{fontWeight: 'bold', textTransform: 'uppercase'}}>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, Vision Sécurité shall not be liable for any indirect, 
            incidental, special, consequential, or punitive damages.
          </p>
          <p>
            In no event shall Vision Sécurité's total aggregate liability exceed One Hundred Canadian Dollars (CAD $100.00) 
            or the amount you paid to access the Website (if any), whichever is greater.
          </p>
        </section>

        <section>
          <h2>14. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless Vision Sécurité from any claims, liabilities, damages, losses, 
            costs, or expenses arising from your use of the Website, violation of these Terms, or violation of any laws or 
            third-party rights.
          </p>
        </section>

        <section>
          <h2>15. Governing Law and Dispute Resolution</h2>
          <h3>Governing Law</h3>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the Province of Quebec and the 
            federal laws of Canada applicable therein.
          </p>
          
          <h3>Jurisdiction</h3>
          <p>
            Any legal action or proceeding arising from these Terms shall be brought exclusively in the courts located in 
            Montreal, Quebec, and you irrevocably consent to the jurisdiction of such courts.
          </p>
          
          <h3>Language of Proceedings</h3>
          <p>
            The parties expressly require that these Terms and all related documents be drafted in English. Les parties 
            conviennent que la présente convention ainsi que tous les documents qui s'y rattachent soient rédigés en anglais.
          </p>
        </section>

        <section>
          <h2>16. General Provisions</h2>
          <p>
            These Terms constitute the entire agreement between you and Vision Sécurité regarding the Website. If any 
            provision is found invalid, the remaining provisions continue in full force. Our failure to enforce any right 
            shall not constitute a waiver.
          </p>
        </section>

        <section>
          <h2>17. Contact Information</h2>
          <p>For questions or concerns regarding these Terms of Use, please contact us:</p>
          <div className="contact-details-box">
            <p><strong>Vision Sécurité Inc.</strong></p>
            <p>Address: 3285 Boul. Cavendish, Suite 620, Montréal, Québec H4B 2L9, Canada</p>
            <p>Email: <a href="mailto:info@vision-security.ca">info@vision-security.ca</a></p>
            <p>Phone: <a href="tel:+15142797209">(514) 279-7209</a></p>
            <p>Legal: <a href="mailto:legal@vision-security.ca">legal@vision-security.ca</a></p>
            <p style={{marginTop: '15px', fontStyle: 'italic'}}>
              For privacy-related inquiries, please contact our Privacy Officer at 
              <a href="mailto:privacy@vision-security.ca"> privacy@vision-security.ca</a>.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
